import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthContext';

/**
 * Sends the short task URL to its canonical form, which names the workspace
 * the task lives in:
 *
 *     /task/<task>?task_id=…  →  /task/<workspace>/<task>?task_id=…
 *
 * Every link builder (`taskUrlForUsecase`, the Projects cards, the
 * breadcrumb, the wizard, the Models / Datasets lists) emits the short form,
 * so mounting this on the `/task/:taskName` route gives every way into a
 * task the workspace segment without touching each caller. The query string
 * and router state (e.g. `showProcessingModal`) travel along unchanged and
 * the history entry is replaced, so Back still leaves the task.
 *
 * Without an active workspace (a session that has none) the task page
 * renders at the short URL as before.
 */
const CanonicalTaskRedirect = ({ children }) => {
    const { workspace } = useAuth();
    const { pathname, search, state } = useLocation();
    if (!workspace?.name) return children;
    // Keep the task segment exactly as it appears in the URL (no decode /
    // re-encode round trip); only the workspace segment is inserted.
    const canonical = `/task/${encodeURIComponent(workspace.name)}${pathname.slice('/task'.length)}`;
    return <Navigate to={{ pathname: canonical, search }} replace state={state} />;
};

export default CanonicalTaskRedirect;
